<template>
  <div class="side-bar">
    <router-link to="/" class="item" :class="{active:routeIs('/')}">
      <span id="collaboration_icon"/>
      <div :class="{hide: collapsed}" class="title">{{$t('home.Cooperation')}}</div>
    </router-link>
    <router-link to="/organ" class="item" :class="{active:routeIs('/organ')}">
      <span id="contacts_icon"/>
      <div :class="{hide: collapsed}" class="title">{{$t('addressBook.Contacts')}}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    collapsed: Boolean
  },
  methods: {
    routeIs(path) {
      return this.$route.path === path
    },
  }
}
</script>

<style scoped lang="scss">
.side-bar {
  height: 100%;
  border-right: 1px solid #EDEFF2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 32px;
  padding-left: 8px;
  padding-right: 8px;

  .item {
    width: 100%;
    margin-bottom: 20px;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    color: #6A6D73;

    &:last-child {
      margin-bottom: 20px;
    }

    & > span {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      margin-right: 12px;
      box-shadow: none;
    }

    #collaboration_icon {
      background: url(~@/assets/sidebar/collaboration.png)
    }
    #contacts_icon {
      background: url(~@/assets/sidebar/contacts.png)
    }
    #workbench_icon {
      background: url(~@/assets/sidebar/workbench.png)
    }

    &:hover {
      background-color: #F3F6FB;
    }

    &.active {
      #collaboration_icon {
        background: url(~@/assets/sidebar/collaboration_active.png)
      }
      #contacts_icon {
        background: url(~@/assets/sidebar/contacts_active.png)
      }
      #workbench_icon {
        background: url(~@/assets/sidebar/workbench_active.png)
      }

      .title {
        color: #333;
      }

      font-weight: bold;

      span {
        box-shadow: 0 10px 20px 0 RGBA(29, 134, 240, .2);
      }
    }

    .title {
      color: #6A6D73;
      word-break: keep-all;

      &.hide {
        opacity: 0;
      }

      transition: opacity 0.2s;
    }
  }
}
</style>
